export default __webpack_public_path__ + "static/media/placeholder-6.b194a155.png";